import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-092fdf04"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "header",
  class: "app-component-header with-back-link"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "d-header"
}
const _hoisted_4 = { class: "d-header__col d-header__left" }
const _hoisted_5 = { class: "d-header__col d-header__middle" }
const _hoisted_6 = { class: "d-header__col d-header__right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header_upload_progress = _resolveComponent("app-header-upload-progress")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["wrapper", {'wrapper-bars': _ctx.spacerHeight === '130px'}])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            (_ctx.mainStore.uploadInfos.length)
              ? (_openBlock(), _createBlock(_component_app_header_upload_progress, {
                  key: 0,
                  uploadInfo: _ctx.mainStore.getUploadInfo
                }, null, 8, ["uploadInfo"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_row, {
            class: "app-component-header__top",
            gutter: 0,
            align: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "top-left", {}, undefined, true)
                ]),
                _: 3
              }),
              _createVNode(_component_el_col, {
                span: 14,
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "top-middle", {}, () => [
                    _createElementVNode("h3", {
                      class: "app-component-header__title",
                      innerHTML: _ctx.descriptionWithLink(_ctx.customTitle ? _ctx.customTitle : _ctx.title)
                    }, null, 8, _hoisted_2)
                  ], true)
                ]),
                _: 3
              }),
              _createVNode(_component_el_col, {
                class: "t-align-right",
                span: 5
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "top-right", {}, undefined, true)
                ]),
                _: 3
              })
            ]),
            _: 3
          }),
          _renderSlot(_ctx.$slots, "bottom", {}, undefined, true)
        ], 512),
        _createElementVNode("div", {
          class: "spacer",
          style: _normalizeStyle('height: ' + _ctx.spacerHeight)
        }, null, 4)
      ], 2))
    : (_openBlock(), _createElementBlock("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "left", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "middle", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "right", {}, undefined, true)
        ])
      ]))
}